document.addEventListener("DOMContentLoaded", function() {
  // Επιλέγει όλα τα links χωρίς τίτλο
  const allLinks = document.querySelectorAll("a:not([title])");
  
  allLinks.forEach(link => {
    // Ορίζει το title attribute με βάση το κείμενο του link
    if (link.textContent.trim()) {
      link.setAttribute("title", link.textContent.trim());
    }
  });
});